"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Profile = void 0;

var Profile =
/** @class */
function () {
  function Profile() {}

  Profile.prototype.EventProfileType = function () {
    return [{
      slug: 'speaker',
      name: 'Speaker',
      description: null,
      isSpeaker: true,
      isPresenter: false,
      isSponsor: false,
      isPanelist: false,
      isModerator: false,
      isHost: false,
      isParticipant: false,
      isOther: false
    }, {
      slug: 'presenter',
      name: 'Presenter',
      description: null,
      isSpeaker: false,
      isPresenter: true,
      isSponsor: false,
      isPanelist: false,
      isModerator: false,
      isHost: false,
      isParticipant: false,
      isOther: false
    }, {
      slug: 'sponsor',
      name: 'Sponsor',
      description: null,
      isSpeaker: false,
      isPresenter: false,
      isSponsor: true,
      isPanelist: false,
      isModerator: false,
      isHost: false,
      isParticipant: false,
      isOther: false
    }, {
      slug: 'panelist',
      name: 'Panelist',
      description: null,
      isSpeaker: false,
      isPresenter: false,
      isSponsor: false,
      isPanelist: true,
      isModerator: false,
      isHost: false,
      isParticipant: false,
      isOther: false
    }, {
      slug: 'moderator',
      name: 'Moderator',
      description: null,
      isSpeaker: false,
      isPresenter: false,
      isSponsor: false,
      isPanelist: false,
      isModerator: true,
      isHost: false,
      isParticipant: false,
      isOther: false
    }, {
      slug: 'host',
      name: 'Host',
      description: null,
      isSpeaker: false,
      isPresenter: false,
      isSponsor: false,
      isPanelist: false,
      isModerator: false,
      isHost: true,
      isParticipant: false,
      isOther: false
    }, {
      slug: 'participant',
      name: 'Participant',
      description: null,
      isSpeaker: false,
      isPresenter: false,
      isSponsor: false,
      isPanelist: false,
      isModerator: false,
      isHost: false,
      isParticipant: true,
      isOther: false
    }, {
      slug: 'other',
      name: 'Other',
      description: null,
      isSpeaker: false,
      isPresenter: false,
      isSponsor: false,
      isPanelist: false,
      isModerator: false,
      isHost: false,
      isParticipant: false,
      isOther: true
    }];
  };

  Profile.prototype.ProfileType = function () {
    return [{
      slug: 'person',
      name: 'Person',
      description: null,
      isPerson: true,
      isCompany: false,
      isOther: false
    }, {
      slug: 'company',
      name: 'Company',
      description: null,
      isPerson: false,
      isCompany: true,
      isOther: false
    }, {
      slug: 'other',
      name: 'Other',
      description: null,
      isPerson: false,
      isCompany: false,
      isOther: true
    }];
  };

  return Profile;
}();

exports.Profile = Profile;